//
//
//
//
//
//
//
//
//
//
//
//
//

import { childMixin } from '../../mixins/multi-items'
import Badge from '../badge'

export default {
  name: 'tabbar-item',
  components: {
    Badge
  },
  mounted () {
    if (!this.$slots.icon) {
      this.simple = true
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true
    }
  },
  mixins: [childMixin],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive () {
      return this.$parent.index === this.currentIndex
    }
  },
  data () {
    return {
      simple: false,
      hasActiveIcon: false
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/tabbar/tabbar-item.vue